import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export default function ArticleCta({
  heading,
  className,
}: {
  heading: string
  className?: string
}) {
  return (
    <aside
      className={cn(
        'flex flex-col items-start gap-4 rounded-xl border bg-card p-6 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <div>
        <p className="text-lg font-semibold">{heading}</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Plans from $30 a month, metered to the byte. A credential is live
          minutes after you sign up.
        </p>
      </div>
      <Button asChild size="lg" className="shrink-0">
        <Link to="/signup">
          Create an account
          <ArrowRight data-icon="inline-end" />
        </Link>
      </Button>
    </aside>
  )
}
